import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, map, Observable } from 'rxjs';

import { DeviceToken, NotificationModel, NotificationsInfo, PaginatedList } from '@shared/models';

import { BaseService } from '../base.service';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationHttpService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  get(loader: string, pageIndex = 0, pageSize = 50, filter = 'All'): Observable<PaginatedList<NotificationModel>> {
    this.loadersService.show(loader);
    return this.http
      .get<PaginatedList<NotificationModel>>(`${this.baseUrl}/notifications`, {
        params: { pageIndex, pageSize, filter },
      })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getDevice(
    loader: string,
    pageIndex = 0,
    pageSize = 50,
    filter = 'All'
  ): Observable<{ items: NotificationModel; totalCount: number }> {
    this.loadersService.show(loader);
    return this.http
      .get<{ items: NotificationModel; totalCount: number }>(`${this.baseUrl}/device`, {
        params: { pageIndex, pageSize, filter },
      })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getById(loader: string, id: string): Observable<NotificationModel> {
    this.loadersService.show(loader);
    return this.http
      .get<NotificationModel>(`${this.baseUrl}/notifications/${id}`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  markAsRead(loader: string, id: string): Observable<NotificationModel> {
    this.loadersService.show(loader);
    return this.http
      .put<NotificationModel>(`${this.baseUrl}/notifications/read/${id}`, null)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  markAllAsRead(loader: string): Observable<void> {
    this.loadersService.show(loader);
    return this.http
      .put<void>(`${this.baseUrl}/notifications/read/all`, null)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  sendNotification(loader: string): Observable<void> {
    this.loadersService.show(loader);
    return this.http
      .get<void>(`${this.baseUrl}/notifications/send`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getNotificationsInfo(loader: string): Observable<NotificationsInfo> {
    this.loadersService.show(loader);
    return this.http
      .get<NotificationsInfo>(this.baseUrl + `/notifications/info`)
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  updateDeviceInfo(loader: string, dto: DeviceToken): Observable<boolean> {
    this.loadersService.show(loader);
    //TODO: move endpoint to notificatiopns controler
    return this.http.post(this.baseUrl + '/auth/device-info', dto, { observe: 'response' }).pipe(
      map((response) => this.isStatusSucceed(response.status)),
      finalize(() => this.loadersService.hide(loader))
    );
  }
}
